import BaseModel from "../../base/baseModel";

import InformacoesNfeModel from "./informacoesProtNfeModel";

export default class ProtocoloNfeModel extends BaseModel {
    informacoes: InformacoesNfeModel = new InformacoesNfeModel();
}
